<template>
	<div>
		<div class="bet-recommendations">
			<div v-if="recommendations.length !== 0">
				<div class="bet-recommendations__header">
					<p>You may be interested in adding these games to your slip</p>
					<carousel
						:paginationEnabled="true"
						:navigationEnabled="true"
						:perPage="1"
						:paginationActiveColor="'var(--green)'"
						:paginationColor="'var(--gray)'"
						:paginationPadding="5"
					>
						<slide
							v-for="(recommendation, idx) in recommendations.slice(0, 5)"
							:key="idx"
							:data-index="idx"
							:title="
								$options.filters.toTitleCase(recommendation.home_team) +
									' vs ' +
									$options.filters.toTitleCase(recommendation.away_team)
							"
						>
							<div class="slider-recommendation__item">
								<div class="slider-recommendation__item__market">
									<div>
										{{ recommendation.home_team | toTitleCase }}
										<span class="slider-recommendation__item__market__name">
											vs
										</span>
										{{ recommendation.away_team | toTitleCase }}
									</div>

									<div class="slider-recommendation__item__market__odds">
										<div
											class="slider-recommendation__item__market__odds__column"
											v-for="(match, idx) in recommendation.markets"
											:key="idx"
										>
											<div
												v-if="match.odds"
												class="
													slider-recommendation__item__market__odds__myodds
													prebet-match__odds
												"
												:number-of-odds="match.odds.length"
											>
												<match-odd
													v-for="(odd, index) in match.odds"
													:key="index"
													:odd="mapOdd(odd, recommendation)"
													:match="recommendation"
													:market="match"
													@added="handleAddRecommendation"
													@removed="handleRemoveRecommendation"
												/>
											</div>
											<div class="slider-recommendation__item__market__time">
												{{
													recommendation.start_time
														| timeFormat("DD/MM[,] HH:mm")
												}}
											</div>
										</div>

										<div
											class="slider-recommendation__item__market__odds__column"
										>
											<div
												class="slider-recommendation__item__market__odds--more"
											>
												<router-link
													:to="{
														name: 'prebet-markets',
														params: { matchId: recommendation.match_id },
													}"
													title="More markets link, opens a new window"
													>More Markets</router-link
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</slide>
						<!-- <slide>See more</slide> -->
					</carousel>
				</div>
				<!-- <div class="bet-recommendations__footer">
					<svg
						class="bet-recommendations__footer--line"
						viewBox="0 0 1 14"
						xmlns="http://www.w3.org/2000/svg"
					>
						<line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="14" />
					</svg>
					<div
						class="bet-recommendations__footer__select"
						@click="canShowBottomSheet = true"
					>
						Don't show this again.
					</div>
				</div> -->
				<!-- <bottom-sheet
					:ref="'bottomSheet'"
					v-if="canShowBottomSheet"
					@close="closeBottomSheet"
					@has-mounted="showBottomSheet"
				>
					<div class="bet-recommendations__bottom_sheet__container">
						<h2>Opt Out?</h2>
						<p>
							You don't want to get recommendations in the future. You can still
							opt-in later on your profile.
						</p>
					</div>
					<div class="bet-recommendations__bottom_sheet__buttons">
						<button
							class="bet-recommendations__bottom_sheet__buttons__apply"
							@click="hideShowRecommendations()"
						>
							Yes, Opt out
						</button>
						<button
							class="bet-recommendations__bottom_sheet__buttons__reset"
							@click="reset"
						>
							Cancel
						</button>
					</div>
				</bottom-sheet> -->
			</div>
		</div>
	</div>
</template>
<script>
import MatchOdd from "../Prebets/MatchOdd.vue";
import Empty from "../Shared/Empty.vue";
import _ from "lodash";
export default {
	name: "RecommendationSlider",
	props: {
		bets: {
			type: Array,
			required: [],
		},
		placingBet: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			canShowBottomSheet: false,
			dontFetchRecommendations: false,
		};
	},
	watch: {
		bets(n, o) {
			let vm = this;
			if (vm.dontFetchRecommendations) {
				vm.dontFetchRecommendations = false;
				return;
			}
			if (n.length > 0) {
				vm.fetchRecommendations();
			}
			if (n.length === 0)
				vm.$store.dispatch("recommendations/getRecommendations", []);
		},
		placingBet(n, o) {
			if (bets.length > 0) {
			}
		},
	},
	components: {
		MatchOdd,
		Empty,
	},
	mounted() {
		this.fetchRecommendations();
	},
	computed: {
		recommendations() {
			let vm = this;
			const recommendations = vm.$store.getters["recommendations/list"].filter(
				(recommendation) => {
					return recommendation.markets !== null;
				}
			);
			return recommendations;
		},
	},
	methods: {
		mapOdd(odd, recommendation) {
			odd.parent_match_id = recommendation.parent_match_id;
			odd.sport_id = recommendation.sport_id;
			return odd;
		},
		handleAddRecommendation(bet) {
			let vm = this;

			// add recommendations to analytics
			vm.$tracking.recommendations.add({
				id: bet.parent_match_id,
				home_team: bet.home_team,
				away_team: bet.away_team,
				market: bet.market,
				odd_key: bet.odd.odd_key,
				odd_value: bet.odd.odd_value,
			});

			// save as added for later placebet tracking
			vm.$store.dispatch(
				"recommendations/getAddedRecommendations",
				bet.parent_match_id
			);
		},
		handleRemoveRecommendation(bet) {
			let vm = this;
			vm.$store.commit(
				"recommendations/removeAddedRecommendations",
				bet.parent_match_id
			);
		},
		fetchRecommendations() {
			let vm = this;

			let matchIds = [];
			vm.bets.forEach(function(value) {
				matchIds.push("sr:match:" + value.parent_match_id);
			});

			let params = {
				event_ids: matchIds.join(),
			};
			return vm.$store.dispatch("recommendations/getRecommendations", params);
		},
		hideShowRecommendations() {
			let vm = this;

			vm.$notifications.add({
				message: "You have opted out successfully.",
				title: "Bet Recommendations",
				type: "info",
				duration: 5000,
			});
			vm.$store.commit("settings/activateCard");

			vm.closeBottomSheet();
		},
		reset() {
			let vm = this;

			vm.closeBottomSheet();
			vm.$emit("reset");
		},
		showBottomSheet() {
			let vm = this;

			vm.canShowBottomSheet = true;
			vm.$nextTick(() => {
				vm.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			let vm = this;

			vm.$refs.bottomSheet.setState("close");
			vm.$nextTick(() => {
				vm.canShowBottomSheet = false;
			});
		},
	},
};
</script>

<style lang="scss">
.slider-recommendation {
	&__item {
		padding: 15px 8px;
		@media (max-width: 320px) {
			padding: 15px 10px;
		}
		border-radius: 8px;
		border: 1px solid var(--light-gray-border);
		background-color: var(--black-dark-20);

		&__close {
			svg {
				width: 12px;
				height: 12px;
			}
			@media (max-width: 320px) {
				svg {
					width: 9px;
					height: 9px;
				}
			}
		}
		&__market {
			color: var(--black);
			font-size: var(--font-large);
			font-weight: var(--font-weight-lighter);
			padding-left: 18px;
			@media (max-width: 320px) {
				font-size: var(--font-small);
				padding-left: 15px;
			}

			&__name {
				color: var(--light-dark-blue);
				font-size: var(--font-small);
				@media (max-width: 320px) {
					font-size: var(--font-smallest);
				}
			}
			&__time {
				color: var(--light-dark-blue);
				font-size: var(--font-smallest);
				padding-top: 15px;
			}
			&__odds {
				font-weight: var(--font-weight-medium);
				font-size: var(--font-small);
				margin-top: 15px;
				display: flex;
				align-items: baseline;
				justify-content: space-between;
				@media (max-width: 320px) {
					margin-top: 10px;
				}
				&--more {
					a {
						color: var(--green);
						text-decoration: none;
						margin-left: 20px;
						@media (max-width: 320px) {
							margin-left: 10px;
						}
					}
				}
				:last-child {
					margin-right: 0px !important;
				}
				&__myodds {
					.prebet-match {
						&__odd {
							padding: 6px 15px;
							margin-right: 5px;
							display: initial;
							line-height: 0rem;
							background-color: var(--line-11);

							&__odd-value {
								font-size: var(--font-smallest);
								line-height: normal;
							}
						}
					}
				}
			}
		}
	}
}
.bet-recommendations {
	background-color: var(--white);
	padding: 10px 20px;
	&__header,
	&__footer {
		color: var(--light-dark-blue);
		font-weight: var(--font-weight-lighter);
		font-size: var(--font-medium);
		p {
			padding-left: 2rem;
			padding-right: 2rem;
		}
		&__select {
			cursor: pointer;
			font-weight: var(--font-weight-medium);
			color: var(--green);

			&--selected {
				color: var(--light-gray);
				pointer-events: none;
			}
		}
		&--line {
			width: 1px;
			height: 14px;
			stroke: var(--gray);
			text-align: center;
		}
	}
	&__header {
		margin: 0px 10px;
		p {
			text-align: center;
			font-size: var(--font-small);
			font-weight: var(--font-weight-lighter);
		}
	}
	&__footer {
		margin-top: 0px;
		text-align: center;
		p {
			margin-top: 5px;
		}
		span:first-child {
			margin-right: 10px;
		}
	}
	&__bottom_sheet {
		&__container {
			padding: 20px 30px;
			max-height: 60vh;
			overflow-y: auto;
			text-align: center;
			p {
				margin: 0;
				color: var(--light-dark-blue);
				font-weight: var(--font-weight-lighter);
			}
		}
		&__buttons {
			padding: 10px;
			&__apply {
				background: var(--green);
				font-style: normal;
				font-weight: var(--font-weight-medium);
				font-size: var(--font-medium);
				line-height: 20px;
				border: none;
				padding: 8px 0;
				text-align: center;
				color: var(--always-white);
				display: block;
				width: 100%;
				margin-bottom: 10px;
			}
			&__reset {
				background: none;
				font-style: normal;
				font-weight: var(--font-weight-medium);
				font-size: var(--font-medium);
				line-height: 20px;
				border: none;
				padding: 8px 0;
				text-align: center;
				color: var(--black);
				display: block;
				width: 100%;
			}
		}
	}
	.VueCarousel {
		&-dot-container {
			margin-top: 0px !important;
			margin-bottom: 15px !important;

			&-dot {
				margin: 5px !important;
				&:focus {
					outline: 1px solid var(--green) !important;
				}
			}
		}

		&-navigation {
			&-button {
				top: 35% !important;
				color: var(--black) !important;
				background: none !important;
				border: none !important;
				padding: 0 5px !important;
				margin: 0 !important;
			}

			:focus {
				outline: 0 !important;
			}
		}
	}
}
</style>
